import * as THREE from 'three';
import store from 'store';

import {
  STATE,
  SynchronizeController,
} from 'services/3dviewer/moving-controls/synchronizeController';

const TRIPOD_LOGO_HAS_IMAGE_RADIUS = 0.16;
const TRIPOD_LOGO_DEFAULT_RADIUS = 0.26;

function IconImage(
  iMainRoomId,
  iHotspotId,
  input_iconTexture,
  input_panelTexture
) {
  const manhattanRotation = 0;
  const texture = null;
  const cameraHeight = null;
  const rotateY = null;
  const hotspotId = iHotspotId;
  const mainRoomId = iMainRoomId;
  let geometry = new THREE.CircleGeometry(TRIPOD_LOGO_DEFAULT_RADIUS, 32);
  const material = new THREE.MeshBasicMaterial({
    map: null,
    side: THREE.DoubleSide,
    transparent: true,
    opacity: 1.0,
    depthTest: false,
  });
  const mesh = new THREE.Mesh(geometry, material);
  const onClickColor = null;
  let mouseIsEnter = null;

  const iconTexture = input_iconTexture;
  const panelTexture = input_panelTexture;

  //hardcode for 21century
  const { queryStringList } = store.getState();
  const isShowCurrentHotSpot =
    queryStringList.isShowCurrentHotSpot === 'false' ? false : true;

  function updateGeometry(radius) {
    // 銷毀舊的 geometry
    geometry.dispose();
    // 建立新的 geometry
    geometry = new THREE.CircleGeometry(radius, 32);
    // 更新 mesh 的 geometry
    mesh.geometry = geometry;
  }

  function update() {
    const { viewButton, viewVariable, currentHotSpot } = store.getState();
    // console.log("icon", this, hotspotId)
    if (viewButton) {
      const { viewState } = viewButton;

      if (viewState == STATE.FPVIEW) {
        setTexture(iconTexture);
        setOpacity(0.0);

        // 根據條件調整 geometry radius
        const targetRadius = input_iconTexture
          ? TRIPOD_LOGO_HAS_IMAGE_RADIUS
          : TRIPOD_LOGO_DEFAULT_RADIUS;
        if (geometry.parameters.radius !== targetRadius) {
          updateGeometry(targetRadius);
        }

        //hardcode for 21century
        if (isShowCurrentHotSpot === true) {
          material.depthTest = false;
          if (hotspotId === currentHotSpot) {
            setOpacity(1.0);
          }
        }
      } else if (viewState == STATE.FLOORPLAN) {
        setTexture(panelTexture);
        setOpacity(1.0);
        material.depthTest = false;

        // 確保在非 FPVIEW 狀態下使用預設 radius
        if (geometry.parameters.radius !== TRIPOD_LOGO_DEFAULT_RADIUS) {
          updateGeometry(TRIPOD_LOGO_DEFAULT_RADIUS);
        }
      } else {
        setTexture(panelTexture);
        setOpacity(1.0);
        material.depthTest = true;

        // 確保在非 FPVIEW 狀態下使用預設 radius
        if (geometry.parameters.radius !== TRIPOD_LOGO_DEFAULT_RADIUS) {
          updateGeometry(TRIPOD_LOGO_DEFAULT_RADIUS);
        }
      }
    }
  }

  function destroy() {
    geometry.dispose();
    material.dispose();
    if (texture) texture.dispose();
  }
  function onMouseEnter() {
    // if (mouseIsEnter === false || mouseIsEnter == null) {
    //   mouseIsEnter = true;
    //   material.opacity = 1;
    // }
  }
  function onMouseLeave() {
    // if (mouseIsEnter === true) {
    //   mouseIsEnter = false;
    //   material.opacity = 0.4;
    // }
  }
  function onClick() {
    // material.color.set(onClickColor);
  }
  function normalizeScale(factor) {
    const newScale = mesh.scale.x * factor;
    mesh.scale.set(newScale, newScale, newScale);
  }
  function setManhattanRotation(iManhattanRotation) {
    this.manhattanRotation = iManhattanRotation;
  }
  function setTexture(iTexture) {
    material.map = iTexture;
    mesh.material = material;
  }
  function setCameraHeight(height) {
    this.cameraHeight = height;
  }
  function setRotateY(iRotateY) {
    this.rotateY = iRotateY;
  }
  function setOpacity(opacity) {
    material.opacity = opacity;
  }
  this.setTexture = setTexture;
  this.setRotateY = setRotateY;
  this.manhattanRotation = manhattanRotation;
  this.normalizeScale = normalizeScale;
  this.onClick = onClick;
  this.rotateY = rotateY;
  this.setCameraHeight = setCameraHeight;
  this.cameraHeight = cameraHeight;
  this.onMouseEnter = onMouseEnter;
  this.onMouseLeave = onMouseLeave;
  this.destroy = destroy;
  this.mainRoomId = mainRoomId;
  this.hotspotId = hotspotId;
  this.setOpacity = setOpacity;
  this.setManhattanRotation = setManhattanRotation;
  this.update = update;

  this.iconTexture = iconTexture;
  this.panelTexture = panelTexture;

  this.updateUnsubscribe = store.subscribe(this.update);
  Object.defineProperty(this, 'rotateY', {
    value: this.rotateY,
    enumerable: true,
  });
  Object.defineProperty(this, 'mesh', {
    value: mesh,
    enumerable: true,
  });
  Object.defineProperty(this, 'cameraHeight', {
    value: this.cameraHeight,
    enumerable: true,
  });
  Object.defineProperty(mesh, 'mainRoomId', {
    value: this.mainRoomId,
    enumerable: true,
  });
  Object.defineProperty(mesh, 'hotspotId', {
    value: this.hotspotId,
    enumerable: true,
  });
  Object.defineProperty(mesh, 'objectType', {
    value: 'iconimage',
    enumerable: true,
  });
  Object.defineProperty(mesh, 'onMouseLeave', {
    value: this.onMouseLeave,
    enumerable: true,
  });
  Object.defineProperty(mesh, 'onMouseEnter', {
    value: this.onMouseEnter,
    enumerable: true,
  });
}
export default IconImage;
